/**
 * Custom i18n messages for the Toolbar customization (CC / subtitles button).
 *
 * Defined here (outside src/customizations/) so the i18n extractor picks
 * them up — it ignores `src/customizations/**`, so a message declared inside
 * a shadow never reaches volto.pot and can never be translated.
 * Imported by the Toolbar shadow.
 */
import { defineMessages } from 'react-intl';

const toolbarMessages = defineMessages({
  subtitles: {
    id: 'SubtitleToolbar.subtitles',
    defaultMessage: 'Subtitles',
  },
});

export default toolbarMessages;
